var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-left",staticStyle:{"margin":"0 auto"},attrs:{"cols":"6","sm":"6"}},[_c('SelectSeries',{ref:"selectSeries",on:{"presetSelectSerie":_vm.presetSelectSerie}})],1)],1),_c('SeriesResults')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }